import { List, Plus } from "@untitledui/icons";
import { EmptyState } from "@/components/application/empty-state/empty-state";
import { SlideoutMenu } from "@/components/application/slideout-menus/slideout-menu";
import { Button } from "@/components/base/buttons/button";

interface RulesListEmptyDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onCreate: () => void;
}

export function RulesListEmptyDrawer({ open, onOpenChange, onCreate }: RulesListEmptyDrawerProps) {
  return (
    <SlideoutMenu isOpen={open} onOpenChange={onOpenChange} isDismissable>
      <SlideoutMenu.Header onClose={() => onOpenChange(false)}>
        <h2 className="text-lg font-semibold text-primary">Cohort Rules</h2>
      </SlideoutMenu.Header>

      <SlideoutMenu.Content className="items-center justify-center">
        <EmptyState size="sm">
          <EmptyState.FeaturedIcon icon={List} color="gray" />
          <EmptyState.Content>
            <EmptyState.Title>No rules yet</EmptyState.Title>
            <EmptyState.Description>
              Create a rule to automatically assign creators to a cohort based on GMV or unit sales.
            </EmptyState.Description>
          </EmptyState.Content>
          <EmptyState.Footer>
            <Button color="primary" iconLeading={Plus} onClick={onCreate}>
              New Rule
            </Button>
          </EmptyState.Footer>
        </EmptyState>
      </SlideoutMenu.Content>
    </SlideoutMenu>
  );
}
